<template>
  <div id="say-trip">
    <div class="relative" v-if="isOpen">
      <div class="card-sticky bg-dark p-3 md:p-4 rounded-tl-xl rounded-bl-xl w-64 md:w-96">
        <div class="flex gap-4">
          <div class="w-4/12 md:w-5/12">
            <img :src="sellerImg" class="rounded-full  border-2 border-primary">
          </div>
          <div class="w-8/12 md:w-6/12  text-white">
            <p class="font-bold text-sm sm:text-lg">{{ agentName }}</p>
            <p class="text-xs md:text-sm uppercase">{{ tr('Travel Specialist') }}</p>
            <div class="hidden md:block">
              <p class="text-sm"><img src="@/assets/trip/img/wpp.svg" class="inline-block mr-2"><span v-html="agentPhone"></span></p>
              <p class=" text-sm "><a :href="agentMeet" target="_blank"><img src="@/assets/trip/img/meet.svg" class="inline-block mr-2">{{ tr('Reserve a meet') }}</a></p>
            </div>
            <a data-modal-target="default-modal" data-modal-toggle="default-modal" @click="showModal = true"
              class="mt-1 md:mt-3 cursor-pointer underline md:no-underline inline-block  md:px-5 py-1 text-sm md:border border-white rounded-sm md:hover:bg-white md:hover:text-dark transition-all">
              {{ tr('More about me') }}</a>

          </div>
        </div>
      </div>
    </div>
    <main v-if="ready">
      <section v-if="loadError" class="max-w-screen-xl mx-auto px-4 py-20 text-center">
        <h1 class="font-secondary text-2xl md:text-3xl mb-4">{{ tr('Itinerary not found') }}</h1>
        <p class="text-dark-gray">{{ tr('The selected group itinerary is not available.') }}</p>
      </section>
      <template v-else>
      <!-- <ExpiredPage v-if="isExpired"></ExpiredPage> -->
      <!-- <template v-else> -->
        <Header v-if="isOpen" :show-designed-for="false"></Header>
        <SectionWhy v-if="isOpen"></SectionWhy>
        <OverviewGroup v-if="isOpen"></OverviewGroup>
        <GroupTravelers v-if="isOpen && !isPersonalized"></GroupTravelers>
        <DayListGroup v-if="isOpen && isPersonalized"></DayListGroup>
        <PricingGroup bookingType="GROUPS" v-if="isOpen && isPersonalized"></PricingGroup>
        <NextStepsGroup bookingType="GROUPS" :viewOnlyInQuote="viewOnlyInQuote" v-if="!isCancelled && !isClosed"></NextStepsGroup>
        <CarbonNeutral v-if="isOpen"></CarbonNeutral>
        <FAQsGroup v-if="viewOnlyInQuote"></FAQsGroup>
        <ClosedText v-if="isClosed"></ClosedText>
        <CancelPage v-if="isCancelled"></CancelPage>
        <Footer></Footer>
      </template>
      <!-- </template> -->
      <!-- Main modal -->
      <div id="default-modal" tabindex="-1"
           :class="{ 'hidden': !showModal, 'flex': showModal }"
           class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
           @keydown.esc="closeModal"
           @click.self="closeModal">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
          <!-- Modal content -->
          <div class="relative bg-white rounded-xl shadow-lg">
            <!-- Modal header -->
            <div class="flex items-center justify-between rounded-t-xl h-64 overflow-hidden">
              <img :src="sellerImgBig" class="object-cover object-center w-full h-full" alt="Seller image">
              <button type="button"
                      class="text-white text-sm w-8 h-8 ms-auto inline-flex absolute top-3 right-3 justify-center items-center"
                      @click="closeModal"
                      aria-label="Close modal">
                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                      viewBox="0 0 14 14">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
              </button>
            </div>
            <!-- Modal body -->
            <div class="p-5 md:p-10 mb:pb-12 space-y-4">
              <div class="text-center mb-2">
                <svg class="mx-auto" width="23" height="14" viewBox="0 0 23 14" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.608918 8.04466L10.9311 13.8498C11.289 14.0501 11.7217 14.0501 12.0795 13.8498L22.3911 8.04466C23.203 7.58728 23.203 6.4046 22.3911 5.94723L12.0769 0.150203C11.7217 -0.0500677 11.289 -0.0500677 10.9311 0.150203L0.608918 5.94723C-0.202973 6.4046 -0.202973 7.58728 0.608918 8.04466Z"
                        fill="#F19F00" />
                </svg>

                <h6 class="text-dark text-xl font-secondary mb-1 mt-3">{{ agentName }}</h6>
                <a class="text-primary text-sm">{{agentEmail}}</a>
              </div>
              <p class="text-sm text-dark opacity-70" v-html="agentDescription">
              </p>
            </div>
            <div class="w-full flex justify-center" v-if="userVideo">
              <a class="text-sm opacity-70 text-dark italic font-bold w-full mt-4 md:mt-2 text-center cursor-pointer mb-4" :href="userVideo" target="_blank">
                {{tr("_YTLink")}}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showModal" class="bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40"></div>

    </main>
    <Transition>
        <BlockUI v-if="!ready"></BlockUI>
    </Transition>
    <VamoosButton v-if="isUser" :groups="true"/>
  </div>
</template>

<script>
import Header from '@/components/itinerary/Header.vue';
import SectionWhy from '@/components/itinerary/SectionWhy.vue';
import OverviewGroup from '@/components/itinerary/OverviewGroup.vue';
import GroupTravelers from '@/components/itinerary/GroupTravelers.vue';
import DayListGroup from '@/components/itinerary/DayListGroup.vue';
import PricingGroup from '@/components/itinerary/PricingGroup.vue';
import NextStepsGroup from '@/components/itinerary/NextStepsGroup.vue';
import CarbonNeutral from '@/components/itinerary/CarbonNeutral.vue';
import FAQsGroup from '@/components/itinerary/FAQsGroup.vue';
import BlockUI from '@/components/tools/BlockUI.vue';
import Footer from '@/components/tools/Footer.vue';
import ClosedText from '../itinerary/ClosedText.vue';
import CancelPage from '../itinerary/CancelPage.vue';
import VamoosButton from '@/components/tools/VamoosButton.vue';
// import ExpiredPage from '../itinerary/ExpiredPage.vue';
import '@/assets/css/main.scss';
const api = window.api;
export default {
  name: 'SayGroups',
  data() {
    return {
      showModal: false,
      loading: true,
      loadingNotes: true,
      status: '',
      expiredDays: null,
      expiredDaysDefault: null,
      loadError: false,
    }
  },
  computed: {
    agentName() {
      return this.$store.state.agentName;
    },
    agentMeet() {
      return this.$store.state.agentMeet;
    },
    agentPhone() {
      return this.$store.state.agentPhone;
    },
    agentEmail() {
      return this.$store.state.agentEmail;
    },
    agentDescription() {
      return this.$store.state.agentDescription;
    },
    sellerImg () {
      return this.$store.state.sellerImg;
    },
    sellerImgBig () {
      return this.$store.state.sellerImgBig;
    },
    ready () {
      return !this.loading && !this.loadingNotes;
    },
    isPersonalized() {
      return Boolean(this.$route.params.name);
    },
    isOpen() {
      return this.status != 'Cerrado' && this.status != 'Cancelado' && this.status != 'Cancel Requiered' && this.status != 'Cancelacion Requerida' && this.status != 'Cancel With Charge' && this.status != 'Cancel No Charge' && this.status != 'Cancel Required' && this.status != 'Cierre Operativo';
    },
    isClosed() {
      return this.status == 'Cerrado' || this.status == 'Cierre Operativo';
    },
    isCancelled() {
      return this.status == 'Cancelado' || this.status == 'Cancel Requiered' || this.status == 'Cancelacion Requerida' || this.status == 'Cancel With Charge' || this.status == 'Cancel No Charge' || this.status == 'Cancel Required';
    },
    userVideo() {
      return this.$store.state.userVideo?.URL;
    },
    viewOnlyInQuote() {
      return this.isOpen && this.fitStatus == 'Quote';
    },
    fitStatus () {
      return this.$store.state.fitStatus;
    },
    isUser() {
      return this.$store.state.isUser;
    },
    modifiedUTCDate() {
      const dateStr = this.$store.state.modifiedUTC;
      const date = new Date(dateStr);
      return date;
    },
    isExpired() {
      const now = new Date();
      let days = this.expiredDays || this.expiredDaysDefault || 15;
      this.$store.commit('setExpireDays', days);
      return this.fitStatus == 'Quote' && this.modifiedUTCDate && now - this.modifiedUTCDate > days * 24 * 60 * 60 * 1000;
    }
  },
  async mounted() {
    const params = {
      ...this.$route.query,
      ...(this.$route.params.name ? { name: this.$route.params.name } : {}),
    };
    const endpoint = (legacy, personalized) => this.isPersonalized ? personalized : legacy;

    api.get(endpoint('/api/groups/group_seller_db', '/api/groups/itinerary_seller_db'), params, null, (r) => {
        if (r) {
          this.$store.commit('setSeller', r);
        }
    });
    let res;
    try {
      res = await api.get(endpoint('/api/groups/group_booking', '/api/groups/itinerary_booking'), params);
    } catch (error) {
      this.loadError = true;
    }
    if (Array.isArray(res) && res.length) {
      this.$store.commit('setDateView', res[0]?.ANALYSIS2);
      api.get(endpoint('/api/groups/group_replace_notes', '/api/groups/itinerary_replace_notes'), params, null, (result) => {
        this.$store.commit('setReplaceNotes', result);
      });
      this.$store.commit('setAgent', res?.[0]?.agent);
      api.get(endpoint('/api/groups/group_cover', '/api/groups/itinerary_cover'), params, null, (result) => {
        this.$store.commit('setNames', {values: result, isPCM: false});
      });
      api.get(endpoint('/api/groups/group_hotel_painting', '/api/groups/itinerary_hotel_painting'), params, null, (result) => {
        this.$store.commit('setGroupHotelPainting', result);
      });
      this.$store.commit('setFITBooking', res);
      api.get(endpoint('/api/groups/group_client_image', '/api/groups/itinerary_client_image'), params, null, (result) => {
        this.$store.commit('setClientImage', result);
      });
      api.get(endpoint('/api/groups/group_passengers', '/api/groups/itinerary_passengers'), params, null, (result) => {
        this.$store.commit('setGroupPassengers', result);
        this.$store.commit('setPaxPrincipal', result);
      });
      this.$store.commit('setQuery', params);
      this.status = res[0]?.Status;
      const showPrices = res[0]?.MostrarPrecios?.trim().toUpperCase() == 'SI'
        && res[0]?.Status == 'Quote';
      this.$store.commit('setHidePrices', !showPrices);
      api.get(endpoint('/api/groups/group_prices', '/api/groups/itinerary_prices'), params, null, (result) => {
        const pricesByItinerary = (result || []).map((row) => {
          const paxCount = Number(row.TOTALPAX) || 0;
          return {
            PaxName: (row.Itinerary || '').trim(),
            PriceTotal: paxCount > 0 ? (Number(row.PriceTotal) || 0) / paxCount : 0,
            PaxCount: paxCount,
          };
        });
        const principal = pricesByItinerary.find(
          (price) => price.PaxName.toUpperCase() === 'PRINCIPAL'
        );
        const principalPrice = principal?.PriceTotal || 0;
        let groupPrices = pricesByItinerary.map((price) => ({
          ...price,
          PriceTotal: price.PaxName.toUpperCase() === 'PRINCIPAL'
            ? price.PriceTotal
            : price.PriceTotal + principalPrice,
        }));
        if (this.isPersonalized) {
          const selectedName = (this.$route.params.name || '').trim().toUpperCase();
          groupPrices = groupPrices.filter(
            (price) => price.PaxName.toUpperCase() === selectedName
          );
        }
        this.$store.commit('setGroupPrices', groupPrices);
      });
      if (this.isPersonalized) {
        api.get('/api/groups/itinerary_price_details', params, null, (result) => {
          this.$store.commit('setFITPriceDetails', result);
        });
      }
      if(res[0]?.GR.trim()) {
        api.get(`/api/tpsql/user_by_gr/${res[0].GR}`, params, null, (res) => {
          this.$store.commit('setGrUser', res);
        })
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    } else {
      this.loadError = this.isPersonalized;
      this.loading = false;
    }
    api.get(endpoint('/api/groups/group_flights', '/api/groups/itinerary_flights'), params, null, (result) => {
      this.$store.commit('setFlights', result);
    });
    api.get(endpoint('/api/groups/group_language_notes', '/api/groups/itinerary_language_notes'), params, null, (r) => {
      this.$store.commit('setLanguageNotes', r);
      setTimeout(() => {
        this.loadingNotes = false;
      }, 1000);
    });
    api.get(`/api/bookingcc_ref/${this.$route.query.Code}`, this.$route.query, null, (result) => {
      this.$store.commit('setCurrencyRate', result);
    });
    api.get(`/api/bookingexpired_ref/${this.$route.query.Code}`, this.$route.query, null, (result) => {
      this.expiredDays = result?.DaysToExpire || null;
    });
    api.get("/api/bookingexpireddefault/", null, null, (res) => {
      if (res) {
        this.expiredDaysDefault = res.DaysToExpire;
      }
    });

  },
  components: {
    Header,
    SectionWhy,
    OverviewGroup,
    GroupTravelers,
    DayListGroup,
    PricingGroup,
    NextStepsGroup,
    CarbonNeutral,
    FAQsGroup,
    BlockUI,
    Footer,
    ClosedText,
    CancelPage,
    VamoosButton,
    // ExpiredPage,
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },

    handleEscKey(event) {
      if (event.key === 'Escape' && this.showModal) {
        this.closeModal();
      }
    },
    tr(key) {
      return this.$root.tr(key);
    }
  },
  watch: {
    showModal(newValue) {
      if (newValue) {
        document.addEventListener('keydown', this.handleEscKey);
      } else {
        document.removeEventListener('keydown', this.handleEscKey);
      }
    }
  },

  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscKey);
  }
}
</script>

<style scoped>
.trip-body {
  overflow: scroll;
}

.v-leave-active {
  transition: opacity 1s ease;
}


.v-leave-to {
  opacity: 0;
}
</style>
